
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Mail } from 'lucide-react';
import { EmailConfig } from '@/types/masterLicenseSettings';
import EmailConfigItem from './EmailConfigItem';

interface EmailConfigListProps {
  emailConfigs: EmailConfig[];
  onAddNew: () => void;
  onEdit: (configId: string) => void;
  onToggleActive: (configId: string, isActive: boolean) => void;
  onSetDefault: (configId: string) => void;
  onDelete: (configId: string) => void;
}

const EmailConfigList: React.FC<EmailConfigListProps> = ({
  emailConfigs,
  onAddNew,
  onEdit,
  onToggleActive,
  onSetDefault,
  onDelete
}) => {
  if (emailConfigs.length === 0) {
    return (
      <div className="text-center py-8 border rounded-lg bg-muted/20">
        <Mail className="h-12 w-12 mx-auto text-muted-foreground mb-2" />
        <h3 className="text-lg font-medium">No Email Configurations</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Add an email configuration to enable sending emails from the master license portal.
        </p>
        <Button variant="default" onClick={onAddNew}>
          <Plus className="mr-2 h-4 w-4" />
          Add Email Configuration
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {emailConfigs.map((config) => (
        <EmailConfigItem
          key={config.id}
          config={config}
          onEdit={onEdit}
          onToggleActive={onToggleActive}
          onSetDefault={onSetDefault}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default EmailConfigList;
